<template>
  <v-row no-gutters row--dense>
    <v-col cols="12">
      <v-card
        outlined
      >
        <v-card-title>
          Items:
        </v-card-title>
        <v-card-text>
          <v-row class="cart">
            <v-col cols="12">
            </v-col>
            <v-col cols="12">
              <v-row align="center" justify="center"
                     v-for="(item, index) in shoppingCart.items" :key="item.id">
                <v-col cols="8" lg="6" class="text-left">
                  <b class="addon-item" v-if="item.parent_cart_item_id">
                    {{ item.description }}
                    <v-chip v-if="item.compulsory" x-small color="primary">Required</v-chip>
                  </b>
                  <b class="service-item" v-else>
                    {{ item.description }}
                  </b>
                  <br v-if="item.upsale">
                  <a
                    v-if="item.upsale"
                    class="upsale"
                    :class="{ 'upsale-disabled': cartInteractionLocked }"
                    :aria-disabled="cartInteractionLocked ? 'true' : 'false'"
                    @click="quickCheckout(247, item.identity)"
                  >
                    Add a Email hosting at SGD5/month
                  </a>
                  <br>
                  <a
                    v-if="item.upsale"
                    class="upsale"
                    :class="{ 'upsale-disabled': cartInteractionLocked }"
                    :aria-disabled="cartInteractionLocked ? 'true' : 'false'"
                    @click="quickCheckout(129, item.identity)"
                  >
                    Add a Web hosting at SGD12/month
                  </a>
                </v-col>
                <v-col cols="4" lg="4" class="text-left">
                  <span :class="{ 'line-through': item.discount && item.discount > 0 }">
                    ${{ item.price }}
                  </span>
                  <span v-if="item.discount && item.discount > 0" class="discounted-price">
                    ${{ item.discounted_price }}
                  </span><br>
                  <span v-if="item.promo">
                    <v-chip
                      x-small
                      color="secondary"
                      label
                      outlined
                    >{{ item.promo_name }}-{{ item.promo.value }}%OFF</v-chip>
                  </span>
                  <span v-if="item.coupon">
                    <v-chip
                      x-small
                      :close="!cartInteractionLocked"
                      color="secondary"
                      label
                      outlined
                      @click:close="removeCoupon(item.coupon.coupon_code)"
                    >{{ item.coupon.coupon_code }}
                    <span v-if="item.coupon.coupon_type == 'p'">-{{ item.coupon.value }}%OFF
                    </span>
                    <span v-if="item.coupon.coupon_type == 'f'">-${{ item.coupon.value }}OFF
                    </span>
                  </v-chip>
                  </span>
                </v-col>
                <v-col cols="12" lg="2" class="text-right">
                  <v-btn color="error" :loading="loadings[index]"
                         :disabled="cartInteractionLocked || item.compulsory"
                         @click="deleteItem(item.id, index)">
                    <v-icon
                      small
                    >
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row justify="end">
                <v-col cols="11" lg="4" class="text-center ">
                  <v-text-field
                    label="Coupon Code"
                    v-model="couponCode"
                    :disabled="cartInteractionLocked"
                  >
                    <template v-slot:append-outer>
                      <v-btn color="primary"
                             @click="addCouponCode"
                             :loading="addCouponLoading"
                             :disabled="cartInteractionLocked">Add</v-btn>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row justify="center">
                <v-col cols="2" lg="8" class="text-center ">
                </v-col>
                <v-col cols="10" lg="4" class="text-right">
                  <h3>Total:
                    <span
                      :class="{'text-decoration-line-through':
                      shoppingCart.total_amount != shoppingCart.total_amount_after_cart_discount}">
                      ${{ shoppingCart.total_amount }}
                    </span>
                    <span
                      class="discounted-price"
                      v-if="
                      shoppingCart.total_amount != shoppingCart.total_amount_after_cart_discount"
                      >
                      ${{ shoppingCart.total_amount_after_cart_discount }}
                    </span>
                    <v-chip
                      x-small
                      :close="!cartInteractionLocked"
                      v-if="shoppingCart.coupon"
                      color="secondary"
                      label
                      outlined
                      @click:close="removeCoupon(shoppingCart.coupon.coupon_code)"
                    >{{ shoppingCart.coupon.coupon_name }}
                      <span>- ${{ shoppingCart.coupon.value }} OFF
                      </span>
                    </v-chip>
                  </h3>
                  <h5
                    v-if="typeof shoppingCart.tax_amount !== 'undefined'
                  && shoppingCart.tax_amount > 0">
                    Inclusive of GST @9%: ${{ shoppingCart.tax_amount }}
                  </h5>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row v-if="showPaymentBlock" class="payment">
            <v-col
              cols="12"
              v-if="paymentMethod == 3"
            >
              <v-form ref="form">
                <v-radio-group v-model="stripePaymentMode">
                <v-radio value="useSavedCard" v-if="hasSavedCard && !airwallexWalletSelected">
                  <template v-slot:label>
                    <div>Use saved card</div>
                  </template>
                </v-radio>
                <v-row no-gutters dense>
                  <v-col cols="6">
                    <stripe-saved-cards
                      :card.sync="savedCard"
                      :hasCard.sync="hasSavedCard"
                      v-on:remove-card="hasSavedCard = false"
                    ></stripe-saved-cards>
                  </v-col>
                </v-row>
                <v-row v-if="hasSavedCard && !airwallexWalletSelected"></v-row>
                <v-radio value="useNewCard" v-if="hasSavedCard && !airwallexWalletSelected">
                  <template v-slot:label>
                    <div>Use new card</div>
                  </template>
                </v-radio>
                <v-row no-gutters dense>
                  <v-col cols="12" md="6">
                    <stripe-payment
                      :amount="shoppingCart.total_amount_after_cart_discount"
                      :card.sync="creditCard"
                      :invalid.sync="creditCardInvalid"
                    ></stripe-payment>
                  </v-col>
                </v-row>
                <v-row no-gutters dense>
                  <v-col cols="12">
                    <v-checkbox
                      v-if="$store.state.brand === 'cldy'"
                      label="Save as default card? I authorise CLDY.com PTE. LTD. to send
                    instructions to the financial institution that issued my card to take payments
                    from my card account in accordance with the terms of my agreement with you."
                      v-model="saveAsDefaultCard"
                    ></v-checkbox>
                    <v-checkbox
                      v-else
                      label="Save as default card? I authorise GOCLOUDEASY PTE. LTD. to send
                    instructions to the financial institution that issued my card to take payments
                    from my card account in accordance with the terms of my agreement with you."
                      v-model="saveAsDefaultCard"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-radio-group>
              </v-form>
            </v-col>
            <v-col
              cols="12"
              v-if="paymentMethod == 4"
            >
              <v-form ref="form">
                <v-radio-group v-model="paypalPaymentMode">
                  <v-radio value="useSavedCard" v-if="hasSavedCard && !airwallexWalletSelected">
                    <template v-slot:label>
                      <div>Use saved card</div>
                    </template>
                  </v-radio>
                  <v-row no-gutters dense>
                    <v-col cols="6">
                      <paypal-saved-cards
                        :card.sync="savedCard"
                        :hasCard.sync="hasSavedCard"
                        v-on:remove-card="hasSavedCard = false"
                      ></paypal-saved-cards>
                    </v-col>
                  </v-row>
                  <v-row v-if="hasSavedCard && !airwallexWalletSelected"></v-row>
                  <v-radio value="useNewCard" v-if="hasSavedCard && !airwallexWalletSelected">
                    <template v-slot:label>
                      <div>Use new card</div>
                    </template>
                  </v-radio>
                  <v-row no-gutters dense>
                    <v-col cols="12" md="6">
                      <paypal-payment
                        :orderid="paypalOrderId"
                        :saveasdefaultcard="saveAsDefaultCard"
                        @interface="getChildInterface"
                        :amount="shoppingCart.total_amount_after_cart_discount"
                        :card.sync="creditCard"
                        :invalid.sync="creditCardInvalid"
                      ></paypal-payment>
                    </v-col>
                  </v-row>
                  <v-row no-gutters dense>
                    <v-col cols="12">
                      <v-checkbox
                        v-if="$store.state.brand === 'cldy'"
                        label="Save as default card? I authorise CLDY.com PTE. LTD. to send
                    instructions to the financial institution that issued my card to take payments
                    from my card account in accordance with the terms of my agreement with you."
                        v-model="saveAsDefaultCard"
                      ></v-checkbox>
                      <v-checkbox
                        v-else
                        label="Save as default card? I authorise GOCLOUDEASY PTE. LTD. to send
                    instructions to the financial institution that issued my card to take payments
                    from my card account in accordance with the terms of my agreement with you."
                        v-model="saveAsDefaultCard"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-radio-group>
              </v-form>
            </v-col>
            <v-col cols="12" v-if="[7, 8].includes(paymentMethod)">
              <v-form ref="form">
                <v-radio-group
                  v-model="airwallexPaymentMode"
                  :disabled="airwallexPaymentSourceLocked"
                >
                  <v-radio
                    value="useSavedCard"
                    v-if="hasSavedCard && !airwallexWalletSelected"
                    :disabled="airwallexPaymentSourceLocked"
                  >
                    <template v-slot:label>
                      <div>Use saved card</div>
                    </template>
                  </v-radio>
                  <v-row no-gutters dense>
                    <v-col cols="6">
                      <airwallex-saved-cards v-if="!airwallexWalletSelected"
                        ref="airwallexSavedCards"
                        :card.sync="savedCard"
                        :hasCard.sync="hasSavedCard"
                        :busy.sync="airwallexSavedCardsBusy"
                        :disabled="airwallexPaymentSourceLocked"
                        v-on:remove-card="hasSavedCard = false"
                      ></airwallex-saved-cards>
                    </v-col>
                  </v-row>
                  <v-radio
                    value="useNewCard"
                    v-if="hasSavedCard && !airwallexWalletSelected"
                    :disabled="airwallexPaymentSourceLocked"
                  >
                    <template v-slot:label>
                      <div>Use new card</div>
                    </template>
                  </v-radio>
                  <v-row
                    v-if="airwallexWalletSelected || !hasSavedCard
                      || airwallexPaymentMode === 'useNewCard'"
                    no-gutters
                    dense
                  >
                    <v-col cols="12" md="6">
                      <airwallex-payment
                        :allow-apple-pay="applePayEnabled"
                      :apple-pay="airwallexWalletSelected"
                      :key="paymentMethod"
                      show-method-selector
                        @apple-pay-selected="selectAirwallexApplePay"
                        :amount="shoppingCart.total_amount_after_cart_discount"
                        :invalid.sync="creditCardInvalid"
                        :disabled="airwallexCardInputLocked"
                        @interface="getAirwallexInterface"
                      ></airwallex-payment>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="airwallexWalletSelected || !hasSavedCard
                      || airwallexPaymentMode === 'useNewCard'"
                    no-gutters
                    dense
                  >
                    <v-col cols="12">
                      <v-checkbox
                        v-if="$store.state.brand === 'cldy'"
                        label="Save as default card? I authorise CLDY.com PTE. LTD. to send
                    instructions to the financial institution that issued my card to take payments
                    from my card account in accordance with the terms of my agreement with you."
                        v-model="saveAsDefaultCard"
                        :disabled="airwallexPaymentSourceLocked || airwallexWalletSelected"
                      ></v-checkbox>
                      <v-checkbox
                        v-else
                        label="Save as default card? I authorise GOCLOUDEASY PTE. LTD. to send
                    instructions to the financial institution that issued my card to take payments
                    from my card account in accordance with the terms of my agreement with you."
                        v-model="saveAsDefaultCard"
                        :disabled="airwallexPaymentSourceLocked || airwallexWalletSelected"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-radio-group>
              </v-form>
            </v-col>
          </v-row>
          <v-row
            v-if="showPaymentBlock && $store.state.brand === 'cldy'"
            no-gutters
            dense
          >
            <v-col cols="12">
              <div class="d-flex justify-end">
                <v-checkbox
                  v-model="tosAccepted"
                  hide-details
                  class="mb-2"
                  :disabled="loading || unpaidLoading || !!tosAuditPromise"
                  @change="recordTosDecision"
                >
                  <template v-slot:label>
                    <div>
                      I have read, understood, and accept the
                      <a
                        href="https://www.cldy.com/sg/terms-of-service/"
                        target="_blank"
                        rel="noopener"
                        @click.stop
                      >Terms of Service</a>.
                    </div>
                  </template>
                </v-checkbox>
              </div>
            </v-col>
          </v-row>
          <v-row v-if="showPaymentBlock" no-gutters dense>
            <v-col cols="12" class="text-right">
              <v-btn color="primary" class="pay-btn"
                     :loading="loading"
                     :disabled="unpaidLoading || externalLoading || cartMutationBusy ||
                     airwallexSavedCardsBusy ||
                     (paymentRequiresCardInput && creditCardInvalid) ||
                     shoppingCart.total_amount_after_cart_discount < 0.01 ||
                     ($store.state.brand === 'cldy' && !tosAccepted)"
                     @click="submit">
                  {{ airwallexWalletSelected
                    ? 'Continue with Apple Pay' : 'Pay by credit card (Visa/Master)' }}
               </v-btn>
            </v-col>
          </v-row>
          <v-row
            v-if="showPaymentBlock && paynowEnabled">
            <v-col cols="12" class="text-right">
              <v-btn color="primary" class="pay-btn"
                     :loading="unpaidLoading"
                     :disabled="loading || externalLoading || cartMutationBusy ||
                     shoppingCart.total_amount_after_cart_discount < 0.01 ||
                     ($store.state.brand === 'cldy' && !tosAccepted)"
                     @click="generatePaynow">Pay by Paynow
              </v-btn>
            </v-col>
          </v-row>
          <v-row
            v-if="showPaymentBlock && typeof $store.state.adminUser.auth_token !== 'undefined'">
            <v-col cols="12">
              <h3>Should you wish to pay using Bank Transfer / Cheque, click on the button below,
                payment information will be sent to your email.
              </h3>
              <h3>Once payment is completed, please follow the email link to notify us of your
                transaction date / time for us to match.
              </h3>
            </v-col>
            <v-col cols="12" class="text-right">
              <v-btn color="primary" class="pay-btn"
                     :loading="unpaidLoading"
                     :disabled="loading || externalLoading || cartMutationBusy ||
                     shoppingCart.total_amount_after_cart_discount < 0.01 ||
                     ($store.state.brand === 'cldy' && !tosAccepted)"
                     @click="generateUnpaid">Pay by bank transfer/cheque
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { getApiBaseUrl } from '@/config/api';
import { mapState } from 'vuex';
import airwallexWallet from '../../mixins/airwallex-wallet';
import {
  StripePayment, StripeSavedCards, PaypalPayment, PaypalSavedCards,
  AirwallexPayment, AirwallexSavedCards,
} from '../components/payment_modules';
import {
  isAirwallexPaymentPending,
  saveAirwallexCardConsent,
} from '../../plugins/airwallex-payment';
import { recordTosDecision as auditTosDecision } from '../../plugins/tos-audit';
import airwallexCartRecovery from '../../mixins/airwallex-cart-recovery';

export default {
  name: 'ShoppingCart',
  mixins: [airwallexWallet, airwallexCartRecovery],
  components: {
    StripeSavedCards,
    StripePayment,
    PaypalSavedCards,
    PaypalPayment,
    AirwallexPayment,
    AirwallexSavedCards,
  },
  data() {
    return {
      valid: false,
      loading: false,
      unpaidLoading: false,
      addCouponLoading: false,
      cartMutationRequests: 0,
      loadings: [],
      saveAsDefaultCard: true,
      creditCardInvalid: true,
      couponCode: '',
      paymentMethod: '',
      paynowEnabled: false,
      paypalOrderId: '',
      creditCard: null,
      savedCard: null,
      hasSavedCard: false,
      airwallexSavedCardsBusy: false,
      stripePaymentMode: 'useNewCard',
      paypalPaymentMode: 'useNewCard',
      airwallexPaymentMode: 'useNewCard',
      rules: {
        required: (value) => !!value || 'This field is required.',
      },
      firstInvoice: false,
      tosAccepted: false,
      tosAuditPromise: null,
      tosAuditSucceeded: true,
    };
  },
  computed: {
    cartMutationBusy() {
      return this.cartMutationRequests > 0;
    },
    cartInteractionLocked() {
      return this.loading
        || this.unpaidLoading
        || this.externalLoading
        || this.cartMutationBusy;
    },
    airwallexPaymentSourceLocked() {
      return this.loading
        || this.airwallexSavedCardsBusy;
    },
    airwallexCardInputLocked() {
      return this.loading
        || this.airwallexSavedCardsBusy;
    },
    paymentRequiresCardInput() {
      return !this.usingSavedCard;
    },
    usingSavedCard() {
      return this.hasSavedCard && (
        (this.paymentMethod === 3 && this.stripePaymentMode === 'useSavedCard')
        || (this.paymentMethod === 4 && this.paypalPaymentMode === 'useSavedCard')
        || (this.paymentMethod === 7 && this.airwallexPaymentMode === 'useSavedCard')
      );
    },
    // eslint-disable-next-line vue/return-in-computed-property
    localComputed() {
    },
    // mix this into the outer object with the object spread operator
    ...mapState({
      shoppingCart: 'shoppingCart',
    }),
  },
  created() {
    this.$api.get('partner/payment-methods')
      .then((response) => {
        this.paymentMethods = this.filterWalletPaymentMethods(response.data);
        this.paynowEnabled = response.data.some((method) => Number(method.id) === 6);
      })
      .catch(() => {
        this.paynowEnabled = false;
      });

    this.$api.get('partner/default-payment-method')
      .then((response) => {
        this.$set(
          this,
          'paymentMethod',
          response.data,
        );
        if (this.paymentMethod === 4) {
          this.creditCardInvalid = false;
        }
      });

    this.$api.get('partner/has-no-invoice')
      .then((response) => {
        this.$set(this, 'firstInvoice', response.data.has_no_invoice);
      });

    this.refreshAirwallexShoppingCartRecovery();
  },
  mounted() {
    this.$emit('mutation-busy', this.cartMutationBusy);
  },
  beforeDestroy() {
    this.$emit('mutation-busy', false);
  },
  methods: {
    beginCartMutation() {
      this.cartMutationRequests += 1;
      this.$emit('mutation-busy', true);
    },
    endCartMutation() {
      this.cartMutationRequests = Math.max(0, this.cartMutationRequests - 1);
      this.$emit('mutation-busy', this.cartMutationBusy);
    },
    quickCheckout(productId, domain) {
      if (this.cartInteractionLocked) {
        return;
      }

      this.beginCartMutation();
      const formData = {
        product_id: productId,
        product_term: 5,
        domain,
        module_data: {
          domain,
        },
        domain_registration: null,
        domain_transfer: null,
      };

      if (this.$store.state.shoppingCartId) {
        formData.shopping_cart_id = this.$store.state.shoppingCartId;
      }

      this.$api.post('partner/product/register', formData)
        .then((data) => {
          if (productId === '129') {
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'success',
              message: 'Web hosting is successfully added to your shopping cart.',
            });
          } else {
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'success',
              message: 'Email hosting is successfully added to your shopping cart.',
            });
          }
          this.syncAirwallexCartRecoveryResponse(data.data);
          this.applyAirwallexCartRecovery(null);
          setTimeout(() => {
            this.goToCart();
          }, 300);
        })
        .finally(() => {
          this.endCartMutation();
        });
    },
    getChildInterface(childInterface) {
      this.$options.childInterface = childInterface;
    },
    getAirwallexInterface(childInterface) {
      this.$options.airwallexInterface = childInterface;
    },
    async saveNewAirwallexCardAsDefault() {
      await saveAirwallexCardConsent(
        this.$api,
        this.$options.airwallexInterface,
      );
      const savedCardResponse = await this.$api.get(
        'partner/payment/get-saved-cards',
        { suppressErrorAlert: true },
      );
      const savedAirwallexCard = savedCardResponse.data;

      if (!savedAirwallexCard || Number(savedAirwallexCard.payment_type_id) !== 7) {
        throw new Error('The saved credit card could not be loaded.');
      }

      this.$set(this, 'savedCard', savedAirwallexCard);
      this.$set(this, 'hasSavedCard', true);
      this.$set(this, 'airwallexPaymentMode', 'useSavedCard');

      if (this.$refs.airwallexSavedCards) {
        this.$refs.airwallexSavedCards.applySavedCard(savedAirwallexCard);
      }
    },
    syncAirwallexCartData(cart) {
      this.$store.dispatch('syncShoppingCart', cart);
    },
    onAirwallexCartRecoveryApplied() {
    },
    async onAirwallexCartRecoveryCompleted(invoice) {
      this.$store.dispatch('resetShoppingCart');
      this.$store.dispatch('addAlert', {
        id: Date.now(),
        type: 'success',
        message: 'Your payment is submitted successfully.',
      });
      try {
        await this.$router.push({
          name: 'Retail.TaxInvoice',
          params: {
            brand: this.$store.state.brand,
            id: invoice.invoice_id,
            first: this.firstInvoice,
          },
        });
      } catch (error) {
        if (!error || error.name !== 'NavigationDuplicated') {
          throw error;
        }
      }
    },
    recordTosDecision(checked) {
      this.tosAuditSucceeded = false;
      const auditRequest = auditTosDecision({
        api: this.$api,
        store: this.$store,
        checked,
        context: 'shopping_cart_payment',
      }).then(() => {
        if (this.tosAuditPromise === auditRequest) {
          this.tosAuditSucceeded = true;
        }
        return true;
      }).catch(() => false).finally(() => {
        if (this.tosAuditPromise === auditRequest) {
          this.tosAuditPromise = null;
        }
      });
      this.tosAuditPromise = auditRequest;
    },
    async waitForTosAudit() {
      let pendingTosAudit = this.tosAuditPromise;
      while (pendingTosAudit) {
        // eslint-disable-next-line no-await-in-loop
        await pendingTosAudit;
        pendingTosAudit = this.tosAuditPromise;
      }
      return this.tosAuditSucceeded
        && !(this.$store.state.brand === 'cldy' && !this.tosAccepted);
    },
    reloadShoppingCart() {
      if (!this.$store.state.user.role) {
        this.airwallexCartRecoveryLoading = false;
        return Promise.resolve(null);
      }

      this.beginCartMutation();
      return this.refreshAirwallexCartRecovery()
        .then(async (response) => {
          const recovery = this.airwallexPaymentRecovery;

          if (recovery && recovery.action === 'completed') {
            try {
              await this.acknowledgeAirwallexCartRecovery(recovery);
            } catch (error) {
              // Recovery acknowledgement is advisory in lock-free cart mode.
            }
          }

          this.applyAirwallexCartRecovery(null);

          return response;
        })
        .finally(() => {
          this.endCartMutation();
        });
    },
    refreshAirwallexShoppingCartRecovery() {
      return this.reloadShoppingCart().catch(() => {
        this.applyAirwallexCartRecovery(null);
        return null;
      });
    },
    deleteItem(itemId, index) {
      if (this.cartInteractionLocked) {
        return;
      }

      this.beginCartMutation();
      this.$set(this.loadings, index, true);

      const { shoppingCartId } = this.$store.state;

      this.$api.delete(`partner/shopping-cart/${itemId}`, {
        data: {
          shopping_cart_id: shoppingCartId,
        },
      })
        .then((data) => {
          this.$set(this, 'loadings', []);
          this.syncAirwallexCartRecoveryResponse(data.data);
          this.applyAirwallexCartRecovery(null);
        })
        .catch(() => {
          this.$set(this.loadings, index, false);
        })
        .finally(() => {
          this.endCartMutation();
        });
    },
    async submit() {
      if (this.loading
        || this.unpaidLoading
        || this.externalLoading
        || this.cartMutationBusy
        || this.airwallexSavedCardsBusy
      ) {
        return;
      }
      this.applyAirwallexCartRecovery(null);

      if (this.$store.state.brand === 'cldy' && !this.tosAccepted) {
        return;
      }
      this.loading = true;

      if (!(await this.waitForTosAudit())) {
        this.loading = false;
        return;
      }

      if (!this.$refs.form.validate()) {
        this.loading = false;
        return;
      }

      if ([7, 8].includes(this.paymentMethod)
        && !this.usingSavedCard
        && this.saveAsDefaultCard
        && !this.airwallexWalletSelected
      ) {
        try {
          await this.saveNewAirwallexCardAsDefault();
        } catch (error) {
          await this.handleAirwallexCartError(error);
          this.loading = false;
          return;
        }
      }

      // Airwallex is the new-card method for staged customers, while an
      // existing saved card must continue through the module that owns it.
      const { usingSavedCard } = this;
      const paymentCardId = usingSavedCard ? this.savedCard.id : null;
      const paymentTypeId = this.paymentMethod === 7 && usingSavedCard
        ? Number(this.savedCard.payment_type_id)
        : this.paymentMethod;

      if (![3, 4, 7, 8].includes(paymentTypeId)) {
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'error',
          message: 'The selected saved card is not supported.',
        });
        this.loading = false;
        return;
      }

      if (paymentTypeId === 3) {
        if (usingSavedCard) {
          this.$api.post('partner/payment/use-saved-card', {
            amount: this.shoppingCart.total_amount_after_cart_discount,
            payment_card_id: paymentCardId,
            payment_type_id: paymentTypeId,
          })
            .then((response) => {
              const stripePaymentObj = {};

              window.stripeClient.confirmCardPayment(response.data.client_secret, stripePaymentObj)
                .then(async (result) => {
                  if (result.error) {
                    await this.$store.dispatch('addAlert', {
                      id: Date.now(),
                      type: 'error',
                      message: result.error,
                    });
                  }

                  if (result.paymentIntent.status === 'requires_capture') {
                    await this.$api.post('partner/payment', {
                      payment_type_id: paymentTypeId,
                      confirm: 1,
                      id: result.paymentIntent.id,
                    })
                      .then(() => {
                        const successMessage = 'Your payment is submitted successfully.';
                        this.$store.dispatch('resetShoppingCart');
                        this.$store.dispatch('addAlert', {
                          id: Date.now(),
                          type: 'success',
                          message: successMessage,
                        });
                        this.reset();
                      });
                  }
                })
                .finally(() => {
                  this.loading = false;
                });
            })
            .catch((error) => {
              if (error.response) {
                const errorMsg = error.response.data.message || error.response.data;

                if (typeof errorMsg === 'string'
                  && errorMsg.indexOf('remove it from the cart') !== -1
                ) {
                  this.refreshAirwallexShoppingCartRecovery();
                }

                this.$store.dispatch('addAlert', {
                  id: Date.now(),
                  type: 'error',
                  message: errorMsg,
                });
              } else {
                this.$store.dispatch('addAlert', {
                  id: Date.now(),
                  type: 'error',
                  message: error.message,
                });
              }
              this.loading = false;
            });
        } else {
          if (this.creditCardInvalid) {
            this.loading = false;
            return;
          }
          this.$api.post('partner/payment', {
            payment_type_id: paymentTypeId,
            amount: this.shoppingCart.total_amount_after_cart_discount,
            save_as_default_card: this.saveAsDefaultCard,
          })
            .then((response) => {
              const stripePaymentObj = {
                payment_method: {
                  card: this.creditCard,
                },
              };

              if (this.saveAsDefaultCard) {
                stripePaymentObj.setup_future_usage = 'off_session';
              }

              window.stripeClient.confirmCardPayment(response.data.client_secret, stripePaymentObj)
                .then(async (result) => {
                  if (result.error) {
                    await this.$store.dispatch('addAlert', {
                      id: Date.now(),
                      type: 'error',
                      message: result.error,
                    });
                  } else if (result.paymentIntent.status === 'requires_capture') {
                    await this.$api.post('partner/payment', {
                      payment_type_id: paymentTypeId,
                      confirm: 1,
                      id: result.paymentIntent.id,
                    })
                      .then(() => {
                        const successMessage = 'Your payment is submitted successfully.';
                        this.$store.dispatch('resetShoppingCart');
                        this.$store.dispatch('addAlert', {
                          id: Date.now(),
                          type: 'success',
                          message: successMessage,
                        });
                        this.reset();
                      });
                  }
                })
                .finally(() => {
                  this.loading = false;
                });
            })
            .catch((error) => {
              if (error.response) {
                const errorMsg = error.response.data.message || error.response.data;

                if (typeof errorMsg === 'string'
                  && errorMsg.indexOf('remove it from the cart') !== -1
                ) {
                  this.refreshAirwallexShoppingCartRecovery();
                }

                this.$store.dispatch('addAlert', {
                  id: Date.now(),
                  type: 'error',
                  message: errorMsg,
                });
              } else {
                this.$store.dispatch('addAlert', {
                  id: Date.now(),
                  type: 'error',
                  message: error.message,
                });
              }
              this.loading = false;
            });
        }
      }

      if (paymentTypeId === 4) {
        if (usingSavedCard) {
          this.$api.post('partner/payment/use-saved-card', {
            payment_type_id: paymentTypeId,
            payment_card_id: paymentCardId,
            amount: this.shoppingCart.total_amount_after_cart_discount,
          })
            .then((response) => {
              this.$set(this, 'paypalOrderId', response.data.order_id);
              this.$nextTick(() => {
                this.$api.post('partner/payment', {
                  payment_card_id: paymentCardId,
                  payment_type_id: paymentTypeId,
                  confirm: 1,
                  id: this.paypalOrderId,
                  amount: this.shoppingCart.total_amount_after_cart_discount,
                })
                  .then((subresponse) => {
                    this.$store.dispatch('resetShoppingCart');
                    this.$store.dispatch('addAlert', {
                      id: Date.now(),
                      type: 'success',
                      message: 'Your payment is submitted successfully.',
                    });

                    this.$router.push({
                      name: 'Retail.TaxInvoice',
                      params: {
                        brand: this.$store.state.brand,
                        id: subresponse.data.invoice_id,
                        first: this.firstInvoice,
                      },
                    });
                  })
                  .catch((error) => {
                    this.$store.dispatch('addAlert', {
                      id: Date.now(),
                      type: 'error',
                      message: `An error occurred ${error.message}. Please retry again.`,
                    });
                    this.loading = false;
                  })
                  .finally(() => {
                    this.loading = false;
                  });
              });
            })
            .catch((error) => {
              if (error.response) {
                const errorMsg = error.response.data.message || error.response.data;

                if (typeof errorMsg === 'string'
                  && errorMsg.indexOf('remove it from the cart') !== -1
                ) {
                  this.refreshAirwallexShoppingCartRecovery();
                }

                this.$store.dispatch('addAlert', {
                  id: Date.now(),
                  type: 'error',
                  message: errorMsg,
                });
              } else {
                this.$store.dispatch('addAlert', {
                  id: Date.now(),
                  type: 'error',
                  message: error.message,
                });
              }
              this.loading = false;
            });
        } else {
          this.$api.post('partner/payment', {
            payment_type_id: paymentTypeId,
            amount: this.shoppingCart.total_amount_after_cart_discount,
            save_as_default_card: this.saveAsDefaultCard,
          })
            .then((response) => {
              this.$set(this, 'paypalOrderId', response.data.order_id);
              this.$nextTick(() => {
                this.$options.childInterface.checkout()
                  .then((payload) => {
                    if (payload.liabilityShift !== 'NO'
                      && payload.authenticationStatus
                      && payload.authenticationStatus !== 'YES') {
                      this.$store.dispatch('addAlert', {
                        id: Date.now(),
                        type: 'error',
                        message: '3D Secure Authentication fails. Please retry again.',
                      });
                      this.loading = false;
                      return;
                    }

                    if (payload.liabilityShift === 'NO'
                      && payload.liabilityShifted === false
                      && payload.authenticationStatus
                      && payload.authenticationStatus === 'NO') {
                      this.$store.dispatch('addAlert', {
                        id: Date.now(),
                        type: 'error',
                        message: 'You have exited 3D Secure Authentication. Please retry again.',
                      });
                      this.loading = false;
                      return;
                    }

                    this.$api.post('partner/payment', {
                      payment_type_id: paymentTypeId,
                      confirm: 1,
                      id: payload.orderId,
                      amount: this.shoppingCart.total_amount_after_cart_discount,
                      save_as_default_card: this.saveAsDefaultCard,
                    })
                      .then((subresponse) => {
                        this.$store.dispatch('resetShoppingCart');
                        this.$store.dispatch('addAlert', {
                          id: Date.now(),
                          type: 'success',
                          message: 'Your payment is submitted successfully.',
                        });

                        this.$router.push({
                          name: 'Retail.TaxInvoice',
                          params: {
                            brand: this.$store.state.brand,
                            id: subresponse.data.invoice_id,
                            first: this.firstInvoice,
                          },
                        });
                      });
                  })
                  .catch((error) => {
                    if (error.message.indexOf('semantically incorrect') > 0
                      || error.message.indexOf('not well-formed') > 0) {
                      this.$store.dispatch('addAlert', {
                        id: Date.now(),
                        type: 'error',
                        message: 'We are sorry, the transaction failed. Please check the card information or try with another card.',
                      });
                    } else {
                      this.$store.dispatch('addAlert', {
                        id: Date.now(),
                        type: 'error',
                        message: `An error occurred ${error.message}. Please retry again.`,
                      });
                    }
                    this.loading = false;
                  })
                  .finally(() => {
                    this.loading = false;
                  });
              });
            })
            .catch((error) => {
              if (error.response) {
                const errorMsg = error.response.data.message || error.response.data;

                if (typeof errorMsg === 'string'
                  && errorMsg.indexOf('remove it from the cart') !== -1
                ) {
                  this.refreshAirwallexShoppingCartRecovery();
                }

                this.$store.dispatch('addAlert', {
                  id: Date.now(),
                  type: 'error',
                  message: errorMsg,
                });
              } else {
                this.$store.dispatch('addAlert', {
                  id: Date.now(),
                  type: 'error',
                  message: error.message,
                });
              }
              this.loading = false;
            });
        }
      }

      if ([7, 8].includes(paymentTypeId)) {
        const paymentMode = usingSavedCard ? 'saved' : 'new';
        this.applyAirwallexCartRecovery(null);
        const confirmPayment = (paymentIntentId) => this.$api.post('partner/payment', {
          payment_type_id: paymentTypeId,
          payment_card_id: paymentCardId,
          confirm: 1,
          id: paymentIntentId,
        });
        const finishPayment = async (response) => {
          if (!response) {
            return;
          }

          const responseRecovery = this.applyAirwallexCartRecoveryFromResponse(response);

          if (responseRecovery && responseRecovery.action === 'completed') {
            await this.completeAirwallexCartRecovery(responseRecovery);
            return;
          }

          if (responseRecovery && responseRecovery.action === 'blocked') {
            throw new Error(
              'The credit card result could not be verified. You may retry checkout; '
                + `this attempt has been recorded for review.${
                  this.airwallexCartSupportReferenceSuffix(responseRecovery)
                }`,
            );
          }

          if (isAirwallexPaymentPending(response)) {
            const paymentIntentId = this
              .resolveAirwallexCartPaymentIntentId(response);

            if (!paymentIntentId) {
              throw new Error('The credit card processor did not return the pending payment details.');
            }

            if (!this.hasAirwallexCartRecoveryPayload(response)) {
              this.rememberAirwallexCartRecovery({
                action: 'check_status',
                recoverable: true,
                payment_intent_id: paymentIntentId,
                mode: paymentMode,
                payment_card_id: paymentCardId,
              });
            }
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'info',
              message: 'Your card authorization is still processing. You may retry checkout with another card; overlapping payments are recorded for review.',
            });
            this.applyAirwallexCartRecovery(null);
            return;
          }

          if (response.data && response.data.invoice_id) {
            await this.completeAirwallexCartInvoice(response.data);
            return;
          }

          if (!responseRecovery || !['check_status', 'finalize'].includes(
            responseRecovery.action,
          )) {
            throw new Error(
              'The payment result could not be verified. You may retry checkout; '
                + 'this attempt was recorded for manual review.',
            );
          }
        };
        const handlePaymentError = (error) => this.handleAirwallexCartError(error);
        const completePayment = (paymentPromise) => paymentPromise
          .then(finishPayment)
          .catch(handlePaymentError)
          .finally(() => {
            this.loading = false;
          });

        if (paymentMode === 'new' && this.creditCardInvalid) {
          this.loading = false;
          return;
        }

        this.rememberAirwallexCartRecovery({
          action: 'authorize',
          recoverable: true,
          payment_intent_id: null,
          mode: paymentMode,
          payment_card_id: paymentCardId,
          amount: Number(
            this.shoppingCart.total_amount_after_cart_discount,
          ).toFixed(2),
        });

        if (paymentMode === 'saved') {
          const authorizationPayload = {
            payment_type_id: paymentTypeId,
            payment_card_id: paymentCardId,
            amount: this.shoppingCart.total_amount_after_cart_discount,
            start_fresh_cart_payment: 1,
          };

          await completePayment(this.$api.post('partner/payment', authorizationPayload)
            .then((response) => {
              const responseRecovery = (
                this.applyAirwallexCartRecoveryFromResponse(response)
              );

              if (responseRecovery && responseRecovery.action === 'completed') {
                return response;
              }

              if (responseRecovery && responseRecovery.action === 'blocked') {
                throw new Error(
                  'The credit card result could not be verified. You may retry checkout; '
                    + `this attempt has been recorded for review.${
                      this.airwallexCartSupportReferenceSuffix(responseRecovery)
                    }`,
                );
              }

              const paymentIntentId = this
                .resolveAirwallexCartPaymentIntentId(response);

              if (!paymentIntentId) {
                throw new Error('The credit card processor did not return payment details.');
              }

              if (!this.hasAirwallexCartRecoveryPayload(response)) {
                this.rememberAirwallexCartRecovery({
                  action: isAirwallexPaymentPending(response)
                    ? 'check_status'
                    : 'finalize',
                  recoverable: true,
                  payment_intent_id: paymentIntentId,
                  mode: paymentMode,
                  payment_card_id: paymentCardId,
                });
              }

              return this.pollAirwallexCartPayment(
                () => confirmPayment(paymentIntentId),
                isAirwallexPaymentPending(response) ? response : null,
              );
            }));
          return;
        }

        await completePayment(this.$api.post('partner/payment', {
          payment_type_id: paymentTypeId,
          amount: this.shoppingCart.total_amount_after_cart_discount,
          start_fresh_cart_payment: 1,
        })
          .then((response) => {
            const responseRecovery = (
              this.applyAirwallexCartRecoveryFromResponse(response)
            );

            if (responseRecovery && responseRecovery.action === 'completed') {
              return response;
            }

            if (responseRecovery && responseRecovery.action === 'blocked') {
              throw new Error(
                'The credit card result could not be verified. You may retry checkout; '
                  + `this attempt has been recorded for review.${
                    this.airwallexCartSupportReferenceSuffix(responseRecovery)
                  }`,
              );
            }

            const paymentIntentId = this
              .resolveAirwallexCartPaymentIntentId(response);

            if (!paymentIntentId) {
              throw new Error('The credit card processor did not return payment details.');
            }

            if (responseRecovery
              && ['check_status', 'finalize'].includes(responseRecovery.action)
            ) {
              return this.pollAirwallexCartPayment(
                () => confirmPayment(paymentIntentId),
                isAirwallexPaymentPending(response) ? response : null,
              );
            }

            if (isAirwallexPaymentPending(response)) {
              if (!this.hasAirwallexCartRecoveryPayload(response)) {
                this.rememberAirwallexCartRecovery({
                  action: 'check_status',
                  recoverable: true,
                  payment_intent_id: paymentIntentId,
                  mode: paymentMode,
                  payment_card_id: paymentCardId,
                });
              }
              return this.pollAirwallexCartPayment(
                () => confirmPayment(paymentIntentId),
                response,
              );
            }

            this.rememberAirwallexCartRecovery({
              action: 'authorize',
              recoverable: true,
              payment_intent_id: paymentIntentId,
              mode: paymentMode,
              payment_card_id: paymentCardId,
            });

            if (!response.data.client_secret) {
              throw new Error('The credit card processor did not return authorization details.');
            }

            if (!this.$options.airwallexInterface) {
              throw new Error('The payment form is not ready. Please retry again.');
            }

            return this.$options.airwallexInterface.confirmIntent(
              paymentIntentId,
              response.data.client_secret,
            ).then(() => {
              this.rememberAirwallexCartRecovery({
                action: 'check_status',
                recoverable: true,
                payment_intent_id: paymentIntentId,
                mode: paymentMode,
                payment_card_id: paymentCardId,
              });
              return this.pollAirwallexCartPayment(
                () => confirmPayment(paymentIntentId),
              );
            });
          }));
      }
    },
    addCouponCode() {
      if (this.cartInteractionLocked) {
        return;
      }

      this.beginCartMutation();
      this.addCouponLoading = true;
      const { shoppingCartId } = this.$store.state;
      this.$api.post('partner/shopping-cart/add-coupon', {
        coupon_code: this.couponCode,
        shopping_cart_id: shoppingCartId,
      }).then((response) => {
        const successMessage = 'Your coupon code is applied successfully.';
        this.couponCode = '';
        this.syncAirwallexCartRecoveryResponse(response.data);
        this.applyAirwallexCartRecovery(null);
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'success',
          message: successMessage,
        });
      }).finally(() => {
        this.addCouponLoading = false;
        this.endCartMutation();
      });
    },
    removeCoupon(couponCode) {
      if (this.cartInteractionLocked) {
        return;
      }

      this.beginCartMutation();
      this.addCouponLoading = true;
      const { shoppingCartId } = this.$store.state;
      this.$api.post('partner/shopping-cart/remove-coupon', {
        coupon_code: couponCode,
        shopping_cart_id: shoppingCartId,
      }).then((response) => {
        const successMessage = 'Your coupon code is removed successfully.';
        this.couponCode = '';
        this.syncAirwallexCartRecoveryResponse(response.data);
        this.applyAirwallexCartRecovery(null);
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'success',
          message: successMessage,
        });
      }).finally(() => {
        this.addCouponLoading = false;
        this.endCartMutation();
      });
    },
    navigateToPaynowInvoice(paymentResponse) {
      const response = paymentResponse
        && typeof paymentResponse === 'object'
        && !Array.isArray(paymentResponse)
        ? paymentResponse
        : {};
      const invoiceId = Number(response.invoice_id);

      if (!Number.isInteger(invoiceId) || invoiceId <= 0) {
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'error',
          message: 'The PayNow invoice response is incomplete. Please refresh your invoices.',
        });
        return Promise.resolve(false);
      }

      const invoiceRoute = {
        name: 'Retail.InvoiceDetail',
        params: {
          brand: this.$store.state.brand,
          id: response.invoice_id,
        },
      };

      this.$store.dispatch('resetShoppingCart');
      return this.$router.replace(invoiceRoute).catch((error) => {
        if (error && error.name === 'NavigationDuplicated') {
          return true;
        }

        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'error',
          message: 'The invoice page could not be opened. Redirecting now.',
        });
        const resolvedRoute = this.$router.resolve(invoiceRoute);

        if (resolvedRoute && resolvedRoute.href) {
          window.location.assign(resolvedRoute.href);
        }

        return false;
      });
    },
    async generatePaynow() {
      if (!this.paynowEnabled
        || this.loading
        || this.unpaidLoading
        || this.externalLoading
        || this.cartMutationBusy
      ) {
        return;
      }
      if (this.$store.state.brand === 'cldy' && !this.tosAccepted) {
        return;
      }
      this.unpaidLoading = true;
      this.loading = true;

      if (!(await this.waitForTosAudit())) {
        this.unpaidLoading = false;
        this.loading = false;
        return;
      }

      this.$api.post('partner/payment-paynow', {
        payment_type_id: 6,
        amount: this.shoppingCart.total_amount_after_cart_discount,
      })
        .then((response) => this.navigateToPaynowInvoice(response.data))
        .finally(() => {
          this.unpaidLoading = false;
          this.loading = false;
        });
    },
    async generateUnpaid() {
      if (this.loading
        || this.unpaidLoading
        || this.externalLoading
        || this.cartMutationBusy
      ) {
        return;
      }
      if (this.$store.state.brand === 'cldy' && !this.tosAccepted) {
        return;
      }
      this.unpaidLoading = true;

      if (!(await this.waitForTosAudit())) {
        this.unpaidLoading = false;
        return;
      }

      this.$api.post('partner/payment-bank-cheque', {
        payment_type_id: 1,
        amount: this.shoppingCart.total_amount_after_cart_discount,
      })
        .then((subresponse) => {
          const successMessage = 'Your invoice is generated successfully.';
          this.$store.dispatch('resetShoppingCart');
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'success',
            message: successMessage,
          });
          window.location.href = `${getApiBaseUrl()}/v1/tax-invoice/${subresponse.data.invoice_no}/view?view_token=${subresponse.data.view_token}&system_currency=${window.systemCurrency}`;
        })
        .finally(() => {
          this.unpaidLoading = false;
        });
    },
    reset() {
      const { brand } = this.$store.state;
      this.$router
        .push({ name: 'Retail.TaxInvoiceList', params: { brand } })
        .catch(() => {
        });
    },
  },
  watch: {
    hasSavedCard: {
      handler(hasSavedCard) {
        if (this.airwallexWalletSelected) {
          this.airwallexPaymentMode = 'useNewCard';
          this.saveAsDefaultCard = false;
          return;
        }
        if (this.loading) {
          return;
        }

        if (hasSavedCard) {
          this.stripePaymentMode = 'useSavedCard';
          this.paypalPaymentMode = 'useSavedCard';
          this.airwallexPaymentMode = 'useSavedCard';
          this.saveAsDefaultCard = false;
        } else {
          this.stripePaymentMode = 'useNewCard';
          this.paypalPaymentMode = 'useNewCard';
          this.airwallexPaymentMode = 'useNewCard';
          this.saveAsDefaultCard = true;
        }
      },
    },
  },
  props: {
    externalLoading: {
      type: Boolean,
      default: false,
    },
    showPaymentBlock: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped>
  .cart {
    max-height: 640px;
    overflow-y: scroll;
  }

  .pay-btn {
    margin-left: 10px;
  }

  .addon-item {
    display:inline-block;
    font-size: 0.775rem;
    padding-left: 20px;
  }

  .upsale {
    font-size: .65rem;
    text-decoration: none;
  }

  .upsale-disabled {
    opacity: .5;
    pointer-events: none;
  }
</style>
